export default __webpack_public_path__ + "static/media/footer-logo.d09865ba.svg";